/**
 * SICH — Email capture interaction.
 * Intercepta el submit del form, envía via fetch al endpoint /contact de Shopify,
 * muestra feedback inline sin reload, resetea el input en éxito.
 */
(function () {
  'use strict';

  window.sichSubmitEmail = async function (event) {
    event.preventDefault();
    const form = event.target;
    const input = form.querySelector('.sich-email-capture__input');
    const button = form.querySelector('.sich-email-capture__submit');
    const message = document.getElementById('sich-email-message');

    const email = input.value.trim();
    if (!email) return;

    // Visual feedback inmediato: deshabilitar
    button.style.opacity = '0.4';
    button.disabled = true;

    try {
      const formData = new FormData(form);

      // Fire-and-forget submit.
      // Shopify captura el customer incluso cuando Cloudflare intercepta la respuesta
      // con su anti-bot challenge. No intentamos interpretar response.ok porque:
      // - Shopify devuelve 302 redirect en submits exitosos.
      // - Cloudflare a veces inyecta su challenge HTML en la respuesta final.
      // - Ambos casos son "éxito" desde el servidor.
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).catch(function (err) {
        // Errores de red se silencian. El submit suele llegar igual al servidor.
        console.warn('[SICH] Network noise on submit (non-blocking):', err);
      });

      // UI: éxito optimista inmediato.
      input.value = '';
      message.textContent = 'Gracias. Te avisamos antes que al resto.';
      message.classList.add('is-visible');

      // Meta Pixel — disparar evento Lead.
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'landing-oi26',
          content_category: 'email-capture'
        });
      }

      // Re-habilitar el botón (visual "completado").
      button.style.opacity = '0.7';
      button.disabled = false;

      // El mensaje se mantiene visible — no desaparece
      // (refuerza el cierre narrativo del opt-in).

    } catch (err) {
      console.error('[SICH] Email capture error:', err);
      message.textContent = 'Hubo un error. Probá de nuevo.';
      message.classList.add('is-visible');
      button.style.opacity = '1';
      button.disabled = false;
    }
  };
})();